import React from 'react';
import { Link } from 'react-router-dom';
export function Blueprint() {
  return <div className="min-h-screen bg-white text-slate-900 font-sans p-8 md:p-16 max-w-5xl mx-auto" data-id="element-680" data-mp="18bvg0ows609x">
      <div className="flex justify-between items-center mb-12 border-b pb-6" data-id="element-681" data-mp="1ce07pi3o4mtx">
        <div data-id="element-682" data-mp="1cg37uuyjbwcd">
          <h1 className="text-4xl font-bold tracking-tight mb-2" data-id="element-683" data-mp="1hctiv3vhg1qx">
            Oversight Insights
          </h1>
          <p className="text-lg text-slate-500" data-id="element-684" data-mp="1mcfzlnais04h">
            Product Architecture & Blueprint
          </p>
        </div>
        <Link to="/app" className="bg-slate-900 text-white px-6 py-3 rounded-md font-medium hover:bg-slate-800 transition-colors" data-id="element-685" data-mp="1r9zcojvhe6uu">
          View Wireframe Prototype &rarr;
        </Link>
      </div>

      <div className="space-y-16" data-id="element-686" data-mp="202jetuazetkf">
        <section data-id="element-687" data-mp="252nxnqzd40dt">
          <h2 className="text-2xl font-semibold mb-6 border-b pb-2" data-id="element-688" data-mp="25374abjkb2cj">
            1. Information Architecture
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-slate-700" data-id="element-689" data-mp="2a2acu5yr3qp9">
            <li data-id="element-690" data-mp="33yusw9imqf8v">
              <strong data-id="element-691" data-mp="33ze99lsmsvks">Marketing / Public:</strong> Home, Features, Pricing,
              Login, Signup
            </li>
            <li data-id="element-692" data-mp="2yxoy865eshwp">
              <strong data-id="element-693" data-mp="2z1crd46xz2aw">App Shell:</strong> Global Navigation (Sidebar), User
              Profile, Notifications
            </li>
            <li data-id="element-694" data-mp="2pytqgpmpuzra">
              <strong data-id="element-695" data-mp="2pzbw2cv9qqbv">Dashboard:</strong> Overview, Pending Actions, Recent
              Activity, High-level Metrics
            </li>
            <li data-id="element-696" data-mp="3mob6nyjbs478">
              <strong data-id="element-697" data-mp="3mqxapo70c1kp">Assessments:</strong> Active, Completed, Drafts, Templates
            </li>
            <li data-id="element-698" data-mp="3ipc4glozaljh">
              <strong data-id="element-699" data-mp="3dwizbwpllb6v">Feedback & Reports:</strong> Individual Reports, Team
              Aggregates, AI Insights
            </li>
            <li data-id="element-700" data-mp="38y7phlzaz0on">
              <strong data-id="element-701" data-mp="38wd09vh00mer">Team / Directory:</strong> Users, Roles, Departments
            </li>
            <li data-id="element-702" data-mp="a8hbbxxzgfil">
              <strong data-id="element-703" data-mp="a87h1y5wnm73">Settings:</strong> Profile, Organization, Billing
              (Future), Integrations
            </li>
          </ul>
        </section>

        <section data-id="element-704" data-mp="od7x63z98n19">
          <h2 className="text-2xl font-semibold mb-6 border-b pb-2" data-id="element-705" data-mp="ococifi7zkjj">
            2. User Roles & Permissions Matrix
          </h2>
          <div className="overflow-x-auto" data-id="element-706" data-mp="tbj1jz6s65c3">
            <table className="w-full text-left border-collapse" data-id="element-707" data-mp="fkw40acralhl">
              <thead data-id="element-708" data-mp="fijqqahy0zav">
                <tr className="bg-slate-50 border-b" data-id="element-709" data-mp="jm7wqoqxfmu0">
                  <th className="p-3 font-medium" data-id="element-710" data-mp="jkoh90d3hfta">Role</th>
                  <th className="p-3 font-medium" data-id="element-711" data-mp="5lx71p1cseaf">Description</th>
                  <th className="p-3 font-medium" data-id="element-712" data-mp="5ojabch7o7mu">Key Permissions</th>
                </tr>
              </thead>
              <tbody className="text-slate-700" data-id="element-713" data-mp="3sr5zidqk3qn4">
                <tr className="border-b" data-id="element-714" data-mp="3sshezatd6mu2">
                  <td className="p-3 font-medium" data-id="element-715" data-mp="3stisdlxurley">System Admin</td>
                  <td className="p-3" data-id="element-716" data-mp="nvn71w3saxw">
                    Manages the entire organization account.
                  </td>
                  <td className="p-3" data-id="element-717" data-mp="1qxosnca92ttf">
                    Manage billing, global settings, all users, view all
                    aggregate data.
                  </td>
                </tr>
                <tr className="border-b" data-id="element-718" data-mp="3fjp2q0zw7djb">
                  <td className="p-3 font-medium" data-id="element-719" data-mp="3bidi69vvlihz">HR / Program Manager</td>
                  <td className="p-3" data-id="element-720" data-mp="3bg0tldvm49vy">Runs assessment cycles.</td>
                  <td className="p-3" data-id="element-721" data-mp="3patd0nemia7t">
                    Create templates, launch assessments, view all reports,
                    manage users.
                  </td>
                </tr>
                <tr className="border-b" data-id="element-722" data-mp="30piom9u2ozh">
                  <td className="p-3 font-medium" data-id="element-723" data-mp="3u8bqmr3l5dm5">Manager / Leader</td>
                  <td className="p-3" data-id="element-724" data-mp="3u81z2z2w6yec">Manages a specific team.</td>
                  <td className="p-3" data-id="element-725" data-mp="c1nkcxwsukew">
                    View team reports, initiate team assessments, evaluate
                    direct reports.
                  </td>
                </tr>
                <tr className="border-b" data-id="element-726" data-mp="2dta6om5qxr51">
                  <td className="p-3 font-medium" data-id="element-727" data-mp="2dw61w2q7m1ps">Employee / Subject</td>
                  <td className="p-3" data-id="element-728" data-mp="28wa80wb87qny">The person being evaluated.</td>
                  <td className="p-3" data-id="element-729" data-mp="2ba6rafqzfr18">
                    Complete self-assessments, view own released reports,
                    nominate evaluators.
                  </td>
                </tr>
                <tr className="border-b" data-id="element-730" data-mp="2k9tv1876p8xg">
                  <td className="p-3 font-medium" data-id="element-731" data-mp="2kav8fjboa7ic">
                    Evaluator (Internal/External)
                  </td>
                  <td className="p-3" data-id="element-732" data-mp="2p72erd7zdl0t">Provides feedback on a subject.</td>
                  <td className="p-3" data-id="element-733" data-mp="1rn8zrwnl8com">
                    Complete assigned evaluations. No access to reports unless
                    granted.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section data-id="element-734" data-mp="26au41tw78hy4">
          <h2 className="text-2xl font-semibold mb-6 border-b pb-2" data-id="element-735" data-mp="26bcatkghmeka">
            3. Core Workflows
          </h2>

          <div className="space-y-8" data-id="element-736" data-mp="18un87ojpr89u">
            <div data-id="element-737" data-mp="1du9lfxzjkoin">
              <h3 className="text-xl font-medium mb-3" data-id="element-738" data-mp="1dtq8kvor0qbh">Assessment Lifecycle</h3>
              <ol className="list-decimal pl-6 space-y-2 text-slate-700" data-id="element-739" data-mp="16aqpys9432t6">
                <li data-id="element-740" data-mp="168nxm1khkxla">
                  <strong data-id="element-741" data-mp="11bnpzm7znms2">Drafting:</strong> HR selects template, defines
                  subjects, sets timeline.
                </li>
                <li data-id="element-742" data-mp="wbjbu2ujz450">
                  <strong data-id="element-743" data-mp="wazuoocq8js1">Nomination:</strong> Subjects nominate
                  peers/reports/managers as evaluators.
                </li>
                <li data-id="element-744" data-mp="nbwafh1tpyby">
                  <strong data-id="element-745" data-mp="nc4kl16kapjg">Approval:</strong> Managers approve nominated
                  evaluators.
                </li>
                <li data-id="element-746" data-mp="ike7wok5jpov">
                  <strong data-id="element-747" data-mp="ijv040o7uhok">Active:</strong> Notifications sent. Evaluators and
                  Subjects complete forms.
                </li>
                <li data-id="element-748" data-mp="8n8cx58f3ejd">
                  <strong data-id="element-749" data-mp="8o1elrsirdun">Analysis:</strong> System aggregates data, AI
                  generates insights.
                </li>
                <li data-id="element-750" data-mp="3n3xzjn5qrv9">
                  <strong data-id="element-751" data-mp="3pq2tbinyt9s">Review:</strong> Manager/HR reviews report before
                  releasing to Subject.
                </li>
                <li data-id="element-752" data-mp="3l6b6aajbus3h">
                  <strong data-id="element-753" data-mp="3l5t1gpiln5jy">Released:</strong> Subject views report and AI
                  coaching tips.
                </li>
              </ol>
            </div>

            <div data-id="element-754" data-mp="3c65za1i1pvpu">
              <h3 className="text-xl font-medium mb-3" data-id="element-755" data-mp="3c6o4hnmork9w">AI Insight Workflow</h3>
              <ol className="list-decimal pl-6 space-y-2 text-slate-700" data-id="element-756" data-mp="3h4pkfzotf3h5">
                <li data-id="element-757" data-mp="3h6u01ew2tqx9">
                  Raw quantitative scores are normalized against benchmarks.
                </li>
                <li data-id="element-758" data-mp="cqj3ntlqsmhz">
                  Qualitative text responses are anonymized and passed through
                  NLP.
                </li>
                <li data-id="element-759" data-mp="3v3z2l4wl07nr">
                  AI identifies recurring themes, strengths, and blind spots
                  (e.g., Subject rates self high on Communication, but
                  Evaluators rate low).
                </li>
                <li data-id="element-760" data-mp="rlyqpenwni4v">
                  AI generates a structured executive summary and actionable
                  coaching recommendations.
                </li>
              </ol>
            </div>
          </div>
        </section>

        <section data-id="element-761" data-mp="11s8fjtzgzvju">
          <h2 className="text-2xl font-semibold mb-6 border-b pb-2" data-id="element-762" data-mp="11srsewa9jtr0">
            4. Database Entity Relationships (High-Level)
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-slate-700" data-id="element-763" data-mp="1flhhxap03gsv">
            <li data-id="element-764" data-mp="1alldjace5ncs">
              <strong data-id="element-765" data-mp="1al27aqw3snel">Organization</strong> (1) has many <strong data-id="element-766" data-mp="mufygxe9yz3j">Users</strong>{' '}
              (N)
            </li>
            <li data-id="element-767" data-mp="mwsgtbny3bh4">
              <strong data-id="element-768" data-mp="it48urveidvc">User</strong> (1) has many <strong data-id="element-769" data-mp="iu5v7shvamsd">Assessments</strong> as
              Subject (N)
            </li>
            <li data-id="element-770" data-mp="wt5j2xxk2xnh">
              <strong data-id="element-771" data-mp="wtopbhdufxlo">Assessment Cycle</strong> (1) has many{' '}
              <strong data-id="element-772" data-mp="ru2bb5q6ydbt">Evaluations</strong> (N)
            </li>
            <li data-id="element-773" data-mp="rshjvoz6bai6">
              <strong data-id="element-774" data-mp="rw594bxl5ar3">Evaluation</strong> (1) belongs to one{' '}
              <strong data-id="element-775" data-mp="286hfwouweg05">Subject</strong> (1) and one <strong data-id="element-776" data-mp="238y1noy7a387">Evaluator</strong>{' '}
              (1)
            </li>
            <li data-id="element-777" data-mp="23b23808mmq5b">
              <strong data-id="element-778" data-mp="1js5ow7y8x6w">Template</strong> (1) has many{' '}
              <strong data-id="element-779" data-mp="1l3c73ss4j1p">Questions/Competencies</strong> (N)
            </li>
            <li data-id="element-780" data-mp="5kludrt7ug0u">
              <strong data-id="element-781" data-mp="5m6oxhfj5yyp">Report</strong> (1) is generated from many{' '}
              <strong data-id="element-782" data-mp="ajyfo84fvf1b">Evaluations</strong> (N)
            </li>
          </ul>
        </section>

        <section data-id="element-783" data-mp="fawzvisjsx9u">
          <h2 className="text-2xl font-semibold mb-6 border-b pb-2" data-id="element-784" data-mp="fbgeapizp3j4">
            5. Future Expansion Support
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-slate-700" data-id="element-785" data-mp="k9rqv80o5s51">
            <li data-id="element-786" data-mp="p8l5j3rozp6s">
              <strong data-id="element-787" data-mp="p8bah1rsiru8">Organization Accounts:</strong> Tenant ID built into all
              core models.
            </li>
            <li data-id="element-788" data-mp="tbr8a1fliy8i">
              <strong data-id="element-789" data-mp="t951w54fyorv">Consultant Marketplace:</strong> Roles support "External
              Consultant" with scoped tenant access.
            </li>
            <li data-id="element-790" data-mp="2v348weaj6jyr">
              <strong data-id="element-791" data-mp="2v3mei1j32ajc">Benchmarking:</strong> Data models separate raw scores
              from normalized percentiles.
            </li>
            <li data-id="element-792" data-mp="3038u2hmdw2vb">
              <strong data-id="element-793" data-mp="2shmtrlq56jh2">Subscription Plans:</strong> Feature flags tied to Org
              subscription tier.
            </li>
          </ul>
        </section>
      </div>

      <div className="mt-16 pt-8 border-t text-center" data-id="element-794" data-mp="2np3g6orgfoc9">
        <Link to="/app" className="inline-block bg-slate-900 text-white px-8 py-4 rounded-md font-medium hover:bg-slate-800 transition-colors text-lg" data-id="element-795" data-mp="2irbmbp791s5f">
          Launch Wireframe Prototype
        </Link>
      </div>
    </div>;
}